import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ArrowExpandeMultipleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ArrowExpandeMultipleIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ArrowExpandeMultipleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowExpandeMultipleIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="ArrowExpandeMultipleIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M16.72 15.264a.867.867 0 0 1 0 1.275L12 21l-4.72-4.461a.867.867 0 0 1 0-1.275.993.993 0 0 1 1.348 0L12 18.451l3.372-3.187a.993.993 0 0 1 1.349 0M18 11a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm-6-8 4.72 4.461a.867.867 0 0 1 0 1.275.995.995 0 0 1-1.25.08l-.098-.08L12 5.549 8.628 8.736a.993.993 0 0 1-1.349 0 .865.865 0 0 1-.079-1.19l.08-.085z"
      />
    </svg>
  )
);
ArrowExpandeMultipleIcon.displayName = "ArrowExpandeMultipleIcon";
export default ArrowExpandeMultipleIcon;
